module.exports = __webpack_public_path__ + "static/media/rv-parking.dbca81e8.webp";